import {Component} from "@angular/core";
import {GO_COMPONENTS} from "../../../enums/e-game-objects";
import {GoBaseComponent} from "../go-base.component";
import {UI_TEXTS} from "../../../enums/e-texts";


@Component({
  selector: "go-res-transaction",
  templateUrl: "./go-res-transaction.component.html"
})


export class GoResTransactionComponent extends GoBaseComponent {
  UI_TEXTS = UI_TEXTS;


  constructor() {
    super(GO_COMPONENTS.RES_TRANSACTION);
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-res-transaction/go-res-transaction.component.ts